<div class="grid-container margin-top margin-bottom-large wrapper">
  <form [formGroup]="form">
    @if (loadComplete) {
      <div class="grid-x grid-margin-x section">
        <div class="cell small-4 medium-6 large-6">
          <h2>{{reportType?.description}}</h2>
        </div>
        <div class="cell small-6 medium-6 large-6">
          <div class="grid-x">
            <div class="cell small-6 medium-6 large-6 text-align-right padding-right bold">Application #:</div>
            <div class="cell small-6 medium-6 large-6 text-align-left">{{appNumber}}</div>
            <div class="cell small-6 medium-6 large-6 text-align-right padding-right bold">Application Status:</div><div class="cell small-6 medium-6 large-6 text-align-left bold">{{applicationState}} </div>
            <div class="cell small-6 medium-6 large-6 text-align-right padding-right bold">
              <view-notes [fieldName]="'apiNumber'" [notes]="getFilteredNotes('apiNumber')" (notesRequested)="handleNotesRequested($event)"></view-notes>
              API #:
            </div>
            <div class="cell small-6 medium-6 large-6 text-align-left">
              <a [href]="urlToWellDetails" target="_blank" rel="noopener noreferrer">   {{ apiNumber }}</a>
            </div>
            <div class="cell small-6 medium-6 large-6 text-align-right padding-right bold">Date Total Depth Reached:</div><div class="cell small-6 medium-6 large-6 text-align-left"> {{totalDepth | date: 'longDate':'+0000'}} </div>
            <div class="cell small-6 medium-6 large-6 text-align-right padding-right bold">Well Name:</div><div class="cell small-6 medium-6 large-6 text-align-left"> {{wellName}} </div>
            <div class="cell small-6 medium-6 large-6 text-align-right padding-right bold">Well Number:</div><div class="cell small-6 medium-6 large-6 text-align-left"> {{wellNumber}} </div>
          </div>
        </div>
        <div class="cell small-12 medium-12 large-12 bold">
          Verify the following:
        </div>
        <div class="cell small-6 medium-3 large-3 text-align-right padding-right bold">
          Company Name:
          <span class="padding-left">
            <view-notes [fieldName]="'organizationName'" [notes]="getFilteredNotes('organizationName')" (notesRequested)="handleNotesRequested($event)"></view-notes>
          </span>
        </div>
        <div class="cell small-6 medium-4 large-4">
          <input type="text" formControlName="organizationName" />
        </div>
        <div class="cell small-12 medium-5 large-5 text-align-right">&nbsp;</div>
        <div class="cell bold small-6 medium-3 large-3 text-align-right padding-right">
          Organization #:
          <span class="padding-left">
            <view-notes [fieldName]="'organization'" [notes]="getFilteredNotes('organization')" (notesRequested)="handleNotesRequested($event)"></view-notes>
          </span>
        </div>
        <div class="cell small-6 medium-4 large-4">
          <input type="text" formControlName="organization" />
        </div>
        <div class="cell small-12 medium-5 large-5">&nbsp;</div>
        <div class="cell bold small-6 medium-3 large-3 text-align-right padding-right">
          RBDMS Owner #:
          <span class="padding-left">
            <view-notes [fieldName]="'rbdmsNumber'" [notes]="getFilteredNotes('rbdmsNumber')" (notesRequested)="handleNotesRequested($event)"></view-notes>
          </span>
        </div>
        <div class="cell small-6 medium-4 large-4 ">
          <input type="text" formControlName="rbdmsNumber" />
        </div>
        <div class="cell small-12 medium-5 large-5">&nbsp;</div>
      </div>
      <hr />
      <div>
        @switch (true) {
          @case (reportType?.typeId == 'PLUG') {
            <app-plugging-report-review [well]="well" [app]="application" [onBaseDocumentTypes]="onBaseDocumentTypes"></app-plugging-report-review>
          }
          @case (reportType?.typeId == 'LOGD') {
            <app-review-logs [app]="application" [onBaseDocumentTypes]="onBaseDocumentTypes"></app-review-logs>
          }
          @case (reportType?.typeId == 'F8B') {
            <app-well-stim-additives-review [well]="well" [app]="application" [onBaseDocumentTypes]="onBaseDocumentTypes"></app-well-stim-additives-review>
          }
          @case (reportType?.typeId == 'F8A') {
            <app-surface-hole-additive-review [well]="well" [app]="application" [onBaseDocumentTypes]="onBaseDocumentTypes"></app-surface-hole-additive-review>
          }
          @case (reportType?.typeId == 'ADS') {
            <app-as-drilled-plat-review [well]="well" [application]="application" [reportType]="reportType" [onBaseDocumentTypes]="onBaseDocumentTypes"></app-as-drilled-plat-review>
          }
          @case (reportType?.typeId == 'F8') {
            <app-preliminary-completion-report-review [organization]="organization" [well]="well" [application]="application" [onBaseDocumentTypes]="onBaseDocumentTypes" [reportType]="reportType" (notesRequested)="handleNotesRequested($event)"></app-preliminary-completion-report-review>
          }
          @case (reportType?.typeId == 'F8F') {
            <app-final-completion-review [organization]="organization" [well]="well" [application]="application" [onBaseDocumentTypes]="onBaseDocumentTypes" [reportType]="reportType"></app-final-completion-review>
          }
        }
      </div>
    } @else {
      <div class="grid-x">
        <div class="cell small-12 medium-12 large-12">
          <text-loader [text]="'Loading Application'" [run]="!loadComplete" [tickType]="'.'" [interval]="1000"></text-loader>
        </div>
      </div>
    }
  </form>
</div>


